import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const deviceRoutes = {
    GET_DEVICE_BY_COMPANY: "/dashboard/machine/device/list-device-company",
}
export default {
    getListDeviceByCompany(companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(deviceRoutes.GET_DEVICE_BY_COMPANY,
                {params: companyId})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron dispositivos de esta compañía");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los dispositivos");
                        return;
                    }
                    const devices = data.info;
                    newData = data.info;
                    this.processOption(devices);
                    newData = devices;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    processOption(devices) {
        devices.forEach(value => {
                value.id = value.code;
                value.label = value.title;
                value.name = value.title;
            }
        );
    },
}